import ProductCatalog from '@components/ProductCatalog'
import ImageCarousel from '@components/ImageCarousel'
import SocialLinks from '@components/SocialLinks'
import styles from '@styles/Home.module.css'
import Navbar from '@components/Navbar'

const Home = () => {
  return (
    <main className={styles.main}>
      <div className={styles.container}>
        <Navbar />
        <ImageCarousel />
        <ProductCatalog />
        <div className={styles.footer}>
          <SocialLinks />
        </div>
      </div>
    </main>
  )
}

export default Home
